(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  // Tabs
  $('.tabs-nav .tab-link').click(function(){
    var tab_id = $(this).attr('data-tab');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    $(this).closest('.collection-tabs').find('.tab-content').removeClass('active');
    $("#"+tab_id).addClass('active');
  });
 

  
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_scrolling_image"] && !Shopify.designMode) return;
  try {
    
/*document.addEventListener("DOMContentLoaded", () => {
	const marquee = document.querySelector(".marquee-inner");
	const speed = 2; // Scrolling Speed
	let scrollAmount = 0;
	let isHovered = false;

	// Duplicates the content
	const marqueeContent = marquee.innerHTML;
	marquee.innerHTML += marqueeContent;

	const startScrolling = () => {
		if (!isHovered) {
			scrollAmount -= speed;
			if (Math.abs(scrollAmount) >= marquee.scrollWidth / 2) {
				scrollAmount = 0;
			}
			marquee.style.transform = `translateX(${scrollAmount}px)`;
		}
		requestAnimationFrame(startScrolling);
	};

	marquee.addEventListener("mouseover", () => {
		isHovered = true;
	});

	marquee.addEventListener("mouseout", () => {
		isHovered = false;
	});

	startScrolling();
});
*/

/*document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".home_logo_marquee .marquee-wrapper");
  const original = wrapper.querySelector(".marquee-inner");

  if (!original) return;

  // Create track wrapper
  const track = document.createElement("div");
  track.classList.add("marquee-track");

  // Move original inside track
  wrapper.appendChild(track);
  track.appendChild(original);

  // Clone
  const clone = original.cloneNode(true);
  track.appendChild(clone);

  let scrollX = 0;
  let isPaused = false;
  const speed = 0.8;

  function step() {
    if (!isPaused) {
      scrollX += speed;
      track.style.transform = `translateX(-${scrollX}px)`;

      if (scrollX >= original.scrollWidth) {
        scrollX = 0; // reset
      }
    }
    requestAnimationFrame(step);
  }

  wrapper.addEventListener("mouseenter", () => (isPaused = true));
  wrapper.addEventListener("mouseleave", () => (isPaused = false));

  step();
});*/


/*document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".home_logo_marquee .marquee-wrapper");
  const original = wrapper.querySelector(".marquee-inner");

  if (!original) return;

  // Create track
  const track = document.createElement("div");
  track.classList.add("marquee-track");
  track.style.display = "flex";
  track.style.willChange = "transform";
  wrapper.appendChild(track);
  track.appendChild(original);

  // Clone
  const clone = original.cloneNode(true);
  track.appendChild(clone);

  let scrollX = 0;
  let isPaused = false;
  const speed = 3;

  function startMarquee() {
    const itemWidth = original.scrollWidth;

    // ✅ start already at 0 so no jump
    scrollX = 0;
    track.style.transform = `translateX(0)`;

    function step() {
      if (!isPaused) {
        scrollX += speed;
        if (scrollX >= itemWidth) {
          // ✅ instead of snapping back to 0, just shift instantly
          scrollX = 0;
        }
        track.style.transform = `translateX(-${scrollX}px)`;
      }
      requestAnimationFrame(step);
    }
    step();
  }

  // Wait for images
  const imgs = track.querySelectorAll("img");
  let loaded = 0;
  imgs.forEach(img => {
    if (img.complete) {
      loaded++;
    } else {
      img.addEventListener("load", () => {
        loaded++;
        if (loaded === imgs.length) startMarquee();
      });
      img.addEventListener("error", () => {
        loaded++;
        if (loaded === imgs.length) startMarquee();
      });
    }
  });
  if (loaded === imgs.length) startMarquee();

  wrapper.addEventListener("mouseenter", () => (isPaused = true));
  wrapper.addEventListener("mouseleave", () => (isPaused = false));
});

*/







  } catch(e) { console.error(e); }
})();
})();
